<template>
  <div class="register">
    <div class="title">
      <p>SDG Open Hack</p>
      <p>新用户注册(registration)</p>
    </div>
    <div class="register-form" v-if="step==1">
      <input type="text" v-model="username" placeholder="请输入电话/电子邮箱(phone/email)" class="username" />
      <input type="text" v-model="nickname" placeholder="请输入姓名(name)" class="nickname" />
      <input type="password" v-model="password" placeholder="请设置密码(password)" class="password" />
      <input type="password" v-model="repeatPassword" placeholder="请确认密码(verify password)" class="repeat-password" />

      <v-select placeholder="选择密保问题(encrypted)" class="v-select" :clearable="false" v-model="security" label="Content"
        :options="securityList"></v-select>
      <input type="text" v-model="securityAnswer" placeholder="密保答案(answer)" class="password" />

      <drag-verify :width="270" :height="40" text="向右滑动验证(slide to right)" success-text="验证成功(success)"
        background="#666666" progress-bar-bg="#c0cd3c" completed-bg="#37813a" handler-bg="#fff" textSize="15px"
        :circle="false" @passcallback="verifyPass = true"></drag-verify>

      <!-- <div class="agreements">
        <input v-model="agree" type="checkbox" id="checkbox" /><label for="checkbox"> 我已阅读并接受用户协议</label>
      </div> -->
         <button class="register-btn" @click="nextStep">注 册(register)</button>

      <div class="go-login"><a @click="goLogin()">返回登录(login)</a></div>
    </div>
    <!-- <div class="register-form" v-if="step==2">
      <v-select class="v-select" :clearable="false" v-model="supplement.identity" label="Content" :options="typeList">
      </v-select>
      <input type="text" v-model="supplement.grade" placeholder="请输入年级(grade)" />
      <input type="text" v-model="supplement.major" placeholder="请输入专业名称(major)" />
      <input type="text" v-model="supplement.studentNumber" placeholder="请输入学号(student number)" />

      <div class="upload-box" v-if="supplement.identity=='校友(alumnus)'">
        <div class="upload-item" :style="{'background-image':`url('${supplement.educationImg}')`}">
          <div class="upload-text" v-if="!supplement.educationImg">
            <span>上传</span>
            <span>学历证图片</span>
            <span>education image</span>
          </div>
          <form class="upload-form" enctype="multipart/form-data">
            <input type="file" name="uploadimg" @change="uploadCover('education',$event)">
          </form>
        </div>
        <div class="upload-item" :style="{'background-image':`url('${supplement.degreeImg}')`}">
          <div class="upload-text" v-if="!supplement.degreeImg">
            <span>上传</span>
            <span>学位证图片</span>
            <span>degree image</span>
          </div>
          <form class="upload-form" enctype="multipart/form-data">
            <input type="file" name="uploadimg" @change="uploadCover('degree',$event)">
          </form>
        </div>
      </div>

      <div class="agreements">
        <input v-model="agree" type="checkbox" id="checkbox" /><label for="checkbox"> 我已阅读并接受用户协议</label>
      </div>
      <button class="register-btn" @click="register">注 册(register)</button>

      <div class="go-login"><a @click="step=1">返回(return)</a></div>
    </div> -->
  </div>
</template>

<script>
  import dragVerify from 'vue-drag-verify'
  import vSelect from 'vue-select'
  import * as uuid from 'uuid';
  import * as qiniu from 'qiniu-js';

  import 'vue-select/dist/vue-select.css'

  export default {
    name: 'register',
    components: {
      vSelect,
      dragVerify
    },
    props: {
      redirectURI: String,
    },
    data() {
      return {
        securityList: [],
        username: '',
        nickname: '',
        password: '',
        repeatPassword: '',
        security: null,
        securityAnswer: '',
        verifyPass: false,
        agree: false,
        step: 1,
        typeList: ['在校生(at school)', '校友(alumnus)'],
        // supplement: {
        //   identity: '在校生(at school)',
        //   grade: '',
        //   major: '',
        //   studentNumber: '',
        //   educationImg: '',
        //   degreeImg: ''
        // },
        isUploadImage: false
      }
    },
    async mounted() {
      this.securityList = await this.$api.account.getSecurityList().then(ret => ret.data)
    },
    methods: {
      getAccountType() {
        if (/^1[3456789]\d{9}$/.test(this.username)) {
          return 'phone'
        }
        // eslint-disable-next-line
        if (/^[A-Za-z0-9]+([_\.][A-Za-z0-9]+)*@([A-Za-z0-9\-]+\.)+[A-Za-z]{2,6}$/.test(this.username)) {
          return 'email'
        }
        return null
      },
      //下一步
      nextStep() {
        let accountType = this.getAccountType()
        if (
          !this.username ||
          !this.nickname ||
          !this.password ||
          !this.repeatPassword
        ) {
          return this.$message.warning('信息填写不完整')
        }

        if (!accountType) {
          return this.$message.warning('请输入合法的手机号或邮箱')
        }

        if (this.password !== this.repeatPassword) {
          return this.$message.warning('两次密码输入不一致')
        }

        if (!this.security || !this.securityAnswer) {
          return this.$message.warning('请设置密保问题和答案')
        }

        if (!this.verifyPass) {
          return this.$message.warning('请向右滑动滑块验证')
        }

        // if (!this.agree) {
        //   return this.$message.warning('请先阅读用户协议')
        // }
        this.register();
      },
      async register() {
        
        // let supplement = this.supplement;
        // if (
        //   !supplement.grade ||
        //   !supplement.major ||
        //   !supplement.studentNumber
        // ) {
        //   return this.$message.warning('信息填写不完整')
        // }
        // if (supplement.identity == "校友(alumnus)" &&
        //   (!supplement.educationImg || !supplement.degreeImg)) {
        //   return this.$message.warning('校友请先上传您的学历证和学位证')
        // }
        const accountType = this.getAccountType()
        const registerRet = await this.$api.account.register({
          Name: this.username,
          NickName: this.nickname,
          Password: this.password,
          Phone: accountType === 'phone' ? this.username : null,
          Email: accountType === 'email' ? this.username : null,
          FK_ProblemGuid: this.security.PK_ProblemGuid,
          Answer: this.securityAnswer,
          // Supplement: JSON.stringify(supplement)
        })
        if (registerRet.status === 0) {
          return this.$message.warning(registerRet.err)
        }
        this.$message.success('注册成功')
        this.goLogin()
      },
      //上传图片
      async uploadCover(type, event) {
        if (this.isUploadImage) return;
        let that = this;
        let catalog = `IMG/TsinghuaShow/user/`;
        let file = event.srcElement.files[0];
        let imgSize = 1048576; //图片限制大小
        if (file.size > imgSize * 10) {
          this.$message.warning('上传图片的大小不能超过5M');
          return
        } 
        else {
          this.isUploadImage = true;
          let qiniuToken = await this.$api.account.uploadToken();
          let typename = file.type.replace('image/', '');
          const filename = uuid.v1() + `.${typename}`;
          const putExtra = {
            fname: file.name, // 原文件名
            params: {},
            mimeType: ['image/png', 'image/jpeg', 'image/gif'] // 上传类型限制
          }
          const config = {
            useCdnDomain: true,
            region: qiniu.region.z2
          }
          let observable = qiniu.upload(file, catalog + filename, qiniuToken.token, putExtra, config);
          observable.subscribe({
            error(err) {
              that.$message.warning(err);
            },
            complete(res) {
              if (type == 'education') that.supplement.educationImg = 'https://img.lessonplan.cn/' + res.key;
              else that.supplement.degreeImg = 'https://img.lessonplan.cn/' + res.key;
              that.isUploadImage = false;
            }
          })
        }
      },

      goLogin() {
        this.$router.push({ name: 'tsinghua-login', query: { redirectURI: this.redirectURI } })
      },
    }
  }
</script>

<style lang="scss" scoped>
  .register {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .title {
    width: 270px;
    color: #5f1d62;
    font-size: 24px;
    margin-bottom: 20px;
  }

  .register-form {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;

    .agreements {
      width: 270px;
      margin-bottom: 8px;
      font-size: 14px;
      color: #888;

      input {
        vertical-align: middle;
      }

      label {
        vertical-align: middle;
      }
    }

    .go-login {
      font-size: 14px;
      color: #666666;
      margin-top: 10px;
      text-align: left;
      width: 100%;
    }

    .upload-box {
      display: flex;
      justify-content: space-between;
      width: 100%;
      padding: 10px 0;

      .upload-item {
        position: relative;
        width: calc(50% - 5px);
        height: 100px;
        background-color: #666;
        color: #fff;
        border-radius: 5px;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;

        .upload-text {
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        }
      }

      .upload-form {
        position: absolute;
        top: 0;
        left: 0;
        opacity: 0;
        width: 100%;
        height: 100%;
        z-index: 1;

        input {
          width: 100%;
          height: 100%;
          cursor: pointer;
        }
      }
    }
  }

  /* 针对小屏幕移动设备 */
  @media only screen and (max-height: 600px) {
    .title {
      display: none;
    }
  }

  /* 针对小屏幕PC */
  @media only screen and (max-width: 1366px) and (max-height: 680px) {
    .title {
      display: none;
    }
  }
</style>